// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Our privacy policy is very simple!',
  text: `We only store three cookies on your computer, which are essential for the proper functioning of this application:
  ARRAffinity (identifies which server instance is being accessed), AuthCookie (authentication) and ConsentCookie
  (Privacy Policy).`,
} as ILanguage;
